export default __webpack_public_path__ + "static/media/icon-online-shopping.52297896.png";